import styled from "styled-components";

import { fontSize, fontWeight, theme } from "@tm/utility/global";
import { deviceType } from "../../../../utils";

export const SummaryCard = styled.div`
  background: ${theme.whiteText};
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  @media ${deviceType.mobile} {
    padding: 16px;
    box-shadow: none;
  }
`;

export const RequestHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const RequestTitle = styled.h3`
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.bold};
  color: ${theme.blackText};
  margin: 0;
  flex: 1;
  min-width: 0;

  @media ${deviceType.mobile} {
    font-size: ${fontSize.font18};
  }
`;

export const RequestIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const RequestSubText = styled.p`
  font-size: ${fontSize.font12};
  color: ${theme.greyText};
  margin: 12px 0 0;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
`;

export const PaxRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: ${fontSize.font12};
  color: ${theme.greyText};
  min-width: 0;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const DesktopPaxWrap = styled.div`
  margin-top: 12px;
`;

export const PaxIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${theme.neonGreen};
  border-radius: 4px;
  padding: 2px;
  flex-shrink: 0;
`;

export const EligibilityCta = styled.button`
  border: none;
  background: transparent;
  color: ${theme.blueText};
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.black};
  cursor: pointer;
  padding: 2px 0;
  white-space: nowrap;
  text-transform: uppercase;
`;

export const DesktopEligibilityCard = styled(SummaryCard)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${deviceType.mobile} {
    display: none;
  }
`;

export const EligibilityTitle = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${theme.greyText};
  margin: 0;
`;

export const CriteriaName = styled.p`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.greyText};
  margin: 0 0 4px;
`;

export const CriteriaDesc = styled.p`
  font-size: 12px;
  color: ${theme.lightGreyText};
  margin: 0;
  line-height: 1.5;
`;
